// Simple wrapper to expose ready function for use in block js files

import { iterate, ready } from 'formstone/utils';

let _siteReady = false;
let _mapsReady = false;
const _mapsReadyCallbacks = [];
let _laxReady = false;
const _laxReadyCallbacks = [];

// Every ready callback runs in one shared queue, so a script that throws
// while initializing would stop every script queued after it. Each one runs
// on its own: an error is still reported in the console, but the rest of the
// page's scripts carry on.
function runReadyCallback(cb) {
  try {
    cb(jQuery);
  } catch (error) {
    console.error(error);
  }
}

//

window.SiteReady = (cb) => {
  // console.log(cb);
  ready(() => {
    if (!_siteReady) {
      // First fire only
      console.log('Site Ready');
    }

    _siteReady = true;

    runReadyCallback(cb);
  });
};

//

window.MapsReady = function(cb) {
  // Push to maps ready if nothing is ready
  if (!_mapsReady || !_siteReady) {
    _mapsReadyCallbacks.push(cb);
  } else {
    runReadyCallback(cb);
  }
}

window.initializeGMaps = function() {
  if (!_mapsReady) {
    // First fire only
    console.log('Maps Ready');
  }

  _mapsReady = true;

  if (!_siteReady) {
    // Push to site ready if GMaps loads first
    window.SiteReady(initMaps);
  } else {
    initMaps();
  }
}

function initMaps() {
  iterate(_mapsReadyCallbacks, (cb) => {
    runReadyCallback(cb);
  });
}

//

window.LaxReady = function(cb) {
  // Push to lax ready if nothing is ready
  if (!_laxReady || !_siteReady) {
    _laxReadyCallbacks.push(cb);
  } else {
    runReadyCallback(cb);
  }
}

window.initializeLax = function() {
  if (!_laxReady) {
    // First fire only
    console.log('Lax Ready');
  }

  _laxReady = true;

  if (!_siteReady) {
    // Push to site ready if lax loads first
    window.SiteReady(initLax);
  } else {
    initLax();
  }
}

function initLax() {
  iterate(_laxReadyCallbacks, (cb) => {
    runReadyCallback(cb);
  });
}